import { device } from 'constants/media-query'
import styled from 'styled-components/macro'

export const DatePickerContainer = styled.div`
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 8px;

  &.error {
    .react-datepicker-wrapper {
      input {
        border: 1px solid #ff0000;
      }
    }
  }

  .date-picker {
    box-sizing: border-box;
    width: 100%;
    height: 44px;
    padding: 20px 10px;
    font-weight: 400;
    font-size: 16px;
    line-height: 9px;
    letter-spacing: -0.075em;
    color: #000000;
    border: 1px solid #9c9c9c;
    border-radius: 5px;
    outline: none;
    box-shadow: none;
    background-color: rgba(245, 245, 245, 1);
    direction: inherit;

    .ant-picker-input {
      /* display: flex;
      flex-direction: row-reverse;
      gap: 10px; */

      input {
        font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
        font-optical-sizing: auto;
        font-weight: 600;
        font-style: normal;
        font-variation-settings: 'wdth' 100;
        font-size: 16px;
        text-align: start;
          
        &::placeholder {
          text-align: start;
      }

      .ant-picker-suffix {
        color: #000000;
      }
    }

    &.personal-details-edit {
      display: flex;
      padding: 16px;
      justify-content: flex-start;
      align-items: center;
      border-radius: 4px;
      border: 1px solid #adafac;
      text-align: start;
      background: transparent;
      font-size: 16px;
      font-weight: 400;
      

      .ant-picker-suffix {
        display: none;
      }

      @media ${device.desktop} {
      }
    }
  }
`
